import { cn } from '@src/lib/utils';
import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';

/** Inline copy-to-clipboard button, flipping to a brief "Copied!" confirmation. Mirrors
 * really-data-ui's CopyChip (axetay/really packages/really-data/ui). */
export function CopyChip({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = () => {
    void navigator.clipboard.writeText(value).then(() => setCopied(true));
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={`Copy ${label}`}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 font-mono text-xs transition-colors',
        copied
          ? 'border-status-good/50 bg-status-good/10 text-status-good'
          : 'border-border bg-card text-muted-foreground hover:border-primary hover:text-primary',
      )}
    >
      {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      {copied ? 'Copied!' : label}
    </button>
  );
}
